import { actionClass } from "../decorators/ReduxDecorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ModalActions = class {
  createModal(modal) {
    return modal;
  }
  hideModal(modal) {
    return modal;
  }
};
ModalActions = __decorateClass([
  actionClass()
], ModalActions);
const ModalActions$1 = new ModalActions();
export {
  ModalActions,
  ModalActions$1 as default
};
//# sourceMappingURL=ModalActions.js.map
